import LinearGauge from "@amzn/meridian/esm/components/linear-gauge";
import Text from "@amzn/meridian/esm/components/text";
import OutlineCard from "../../OutlineCard";

const ProgressIndicator = ({ label, current, max, unit }) => {
  const safeMax = max > 0 ? max : 1;
  const safeCurrent = Math.min(current || 0, safeMax);

  return (
    <OutlineCard spacing="200">
      {label && <Text type="h50">{label}</Text>}
      <LinearGauge minValue={0} maxValue={safeMax} value={safeCurrent} trackWidth={8} height={8} />
      <Text type="b200" color="secondary">
        {current || 0}/{max || 0} {unit || "items"}
      </Text>
    </OutlineCard>
  );
};

export default ProgressIndicator;
